import React from "react";
import { useTranslation } from "react-i18next";
import { Bot } from "lucide-react";

import useAiCredit from "@/hooks/useAiCredit";

export const formatCredit = (amount, language) =>
  new Intl.NumberFormat(language || undefined, { style: "currency", currency: "EUR" }).format(amount || 0);

/**
 * Header chip showing the AI credit used this month. Clicking it opens
 * "Mon profil → Compte", where the monthly and lifetime totals are detailed.
 */
export default function AiCreditBadge({ onClick, className = "" }) {
  const { t, i18n } = useTranslation();
  const usage = useAiCredit();
  if (!usage) return null;

  const month = usage.current_month || {};
  const amount = formatCredit(month.credit_eur, i18n.language);
  const tooltip = t("aiCredit.badgeTooltip", { amount, count: month.calls || 0 });

  return (
    <button
      type="button"
      data-testid="ai-credit-badge"
      onClick={onClick}
      title={tooltip}
      aria-label={tooltip}
      className={`items-center gap-1.5 border border-stone-200 text-neutral-700 hover:border-neutral-950 hover:text-neutral-950 px-2.5 py-1 rounded-sm text-xs font-semibold tabular-nums transition-colors ${className}`}
    >
      <Bot className="w-3.5 h-3.5 text-[#E05236]" strokeWidth={2} />
      <span className="text-[10px] uppercase tracking-[0.15em] text-neutral-500">{t("aiCredit.badge")}</span>
      {amount}
    </button>
  );
}
